import { CaseType } from "@/Case/services/CaseType";
import { CaseAccessConditions } from "@/Case/store/functions/caseAccessConditions";

export const shouldAllowCaseAccess = (type: CaseType) => {
  return CaseAccessConditions[type];
};
